/** Feed ingestion modes */
export var FeedIngestMode;
(function (FeedIngestMode) {
    FeedIngestMode[FeedIngestMode["Ftp"] = 0] = "Ftp";
    FeedIngestMode[FeedIngestMode["Sftp"] = 1] = "Sftp";
    FeedIngestMode[FeedIngestMode["Ftps"] = 2] = "Ftps";
    FeedIngestMode[FeedIngestMode["Https"] = 3] = "Https";
    FeedIngestMode[FeedIngestMode["Http"] = 4] = "Http";
})(FeedIngestMode || (FeedIngestMode = {}));
